export interface IAuthLogin {
  userId: number;
  accessToken: string;
  refreshToken: string;
}

export interface IAuthToken {
  sub: string;
  exp: number;
  iat: number;
  username: string;
  person: {
    firstName: string;
    lastName: string;
    middleName: string;
  };
  groups: string[];
  membership: {
    direct: number[];
    inherited: number[];
  };
  permits: IPermissions;
}

export type IPermissions = { [key: string]: number[] };

export enum Permits {
  LECTURER_GIVE_CLASSES = 'lecturers:give-classes',
  STUDENT_GROUP_HEAD_STUDENT = 'student_groups:head-student',
  STUDENT_GROUP_ANALYTICS = 'student_groups:analytics',
}
